import React from 'react';
import './ContinueAsCard.css';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import { primeStorageAccess } from '../../lib/identity/crossDomainIdentity';
import { useLanguageContext } from '../../core/locale/LanguageContext';

interface ContinueAsCardProps {
  displayNumber: string;
  loading: boolean;
  onContinue: () => void;
  onUseAnotherNumber: () => void;
}

function ContinueAsCard({
  displayNumber,
  loading,
  onContinue,
  onUseAnotherNumber,
}: ContinueAsCardProps): React.ReactNode {
  const languageContext = useLanguageContext();

  const onInternalContinue = () => {
    primeStorageAccess();
    onContinue();
  };

  return (
    <div className="continue-as-card">
      <PrimaryButton
        loading={loading}
        onClick={onInternalContinue}
        aria-label={languageContext.getLocalizedText('continueAsLabel', displayNumber)}
      >
        {languageContext.getLocalizedText('continueAsLabel', displayNumber)}
      </PrimaryButton>
      <button
        type="button"
        className="continue-as-use-another"
        data-testid="use-another-number-button"
        onClick={onUseAnotherNumber}
      >
        {languageContext.getLocalizedText('useAnotherNumberLabel')}
      </button>
    </div>
  );
}

export default ContinueAsCard;
